import React, { useState, useEffect } from "react";
import { EnvironmentalDataContext } from "./context";

import {
  getEnvironmentalData,
  getAverageEnvironmentalData,
} from "../services/services";

const EnvironmentalProvider = ({ children }) => {
  const [environmentalData, setEnvironmentalData] = useState(null);
  const [averageEnvironmentalData, setAverageEnvironmentalData] =
    useState(null);
  const [loading, setLoading] = useState(true);
  const [averageLoading, setAverageLoading] = useState(true);
  const [error, setError] = useState(null);
  const [averageError, setAverageError] = useState(null);

  useEffect(() => {
    const fetchEnvironmental = async () => {
      const environmental = await getEnvironmentalData({ lang: "el" })
        .then((response) => {
          if (response.length > 0) {
            setLoading(false);
            return response;
          } else {
            setLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
        });

      setEnvironmentalData(environmental);
    };

    const fetchAverageEnvironmental = async () => {
      const averageEnvironmental = await getAverageEnvironmentalData({
        lang: "el",
      })
        .then((response) => {
          if (response.length > 0) {
            setAverageLoading(false);
            return response;
          } else {
            setAverageLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setAverageLoading(false);
          setAverageError(error);
        });

      setAverageEnvironmentalData(averageEnvironmental);
    };

    fetchEnvironmental();
    fetchAverageEnvironmental();
  }, []);

  return (
    <EnvironmentalDataContext.Provider
      value={{
        environmentalData,
        setEnvironmentalData,
        averageEnvironmentalData,
        setAverageEnvironmentalData,
        loading,
        error,
        averageLoading,
        averageError,
      }}
    >
      {children}
    </EnvironmentalDataContext.Provider>
  );
};

export default EnvironmentalProvider;
